<template>
  <div class="runner-manager">
    <sub-navigation :items="menuItems"/>

    <container>
      <router-view></router-view>
    </container>
  </div>
</template>

<script>
import Container from '@/components/Container'
import SubNavigation from '@/components/SubNavigation'
import PageTitle from '@/components/PageTitle'

export default {
  name: 'RunnerManager',
  data: () => ({
    menuItems: [
      { to: '/admin/runners/allrunners', title: 'All Runners' },
      { to: '/admin/runners/with-run-completed', title: 'Days Since Last LiveRun' },
      { to: '/admin/runners/all-lucky-liverunners', title: 'Lucky LiveRunner' }
    ]
  }),
   
  created() {
    
      if(this.$auth.user().id != 287 && this.$auth.user().id!=2977 && this.$auth.user().id!=2750 && this.$auth.user().id != 1260  && this.$auth.user().id != 6 && this.$auth.user().id!= 14 && this.$auth.user().id!= 11){
          this.$router.push({ path: '/403' })
      }
  },
  components: {
    Container,
    PageTitle,
    SubNavigation
  }
}
</script>

<style lang="stylus" scoped>
  .container
    margin 20px auto 0
</style>



// WEBPACK FOOTER //
// RunnerManager.vue?7583ab74